import { Component, Input, OnInit, output, input, ChangeDetectionStrategy } from '@angular/core';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { MaterialModule } from '../../material.module';
import { JkfieldlabelComponent } from '../jkfieldlabel/jkfieldlabel.component';
import { FormsModule } from '@angular/forms';

import { idNameItem } from '../../services/jkInterface';
import { jkLib } from '../../services/jkCommon';
/*
export class CustomAlertOptions  {
  header: 'Pizza Toppings';
  subHeader: 'Select your favorite topping';
  message: 'Choose only one';
  translucent: true;
};

export class CustomPopoverOptions {
  header: 'Hair Color';
  subHeader: 'Select your hair color';
  message: 'Only select your dominant hair color';
};

export class CustomActionSheetOptions  {
  header: 'Colors';
  subHeader: 'Select your favorite color';
};
*/
@Component({
    selector: 'app-jkcomboboxN',
    templateUrl: './jkcomboboxN.component.html',
    //styleUrls: [''],
    styles: [``],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    MaterialModule,
    FormsModule,
    JkfieldlabelComponent
],
})
export class JkComboboxNComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'jkcombobox';
  override flexStyle:any = { display: 'flex'};
  public readonly items = input<idNameItem[]>([]);
  _value: number = 0;
  tabIndex: number = 0;
  readonly canSpace = input<boolean>(false); // 可空白不選
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()  set value(value:number){
    this._value = value;
  }
  get value(){
    return this._value;
  }
  get itemIndex(): number{
    return this.items().findIndex(item => item.id === this._value.toString());
  }
  set itemIndex(value: number){
    if(value >= 0 && value < this.items().length)
      this._value = jkLib.fixNumber(this.items()[value].id);
    else
      this._value = 0;
  }
  /*_valueN: number = 0;
  @Input()
  set valueN(value:number){// 有在用 不要再刪
    this._valueN = value; // = jkLib.fixString(value);
    if(this._valueN === null || this._valueN === undefined)
      this._value = '';
    else
      this._value = this._valueN.toString();
  }
  get valueN(): number{
    if(this._value === '' || this._value === null)
      return 0
    else
      return Number(this._value);
    //return this._valueN;
  }*/
  readonly valueChange = output<number>();
  //@Output() valueNChange = new EventEmitter<number>();
  onValueChange(newValue: number) {
    if(this.valueChange)
      this.valueChange.emit(newValue);
  }
  constructor() {
    super();
   }

  override ngOnInit() {
    super.ngOnInit();
  }
  addWhere(where: string,fieldName:string,condition:string = '='): string {
    if(this.value){
      //where += ' AND ('+fieldName + ' = ' + jkLib.quotedStr(this.value)+') ';
      where = jkLib.number2Where(this.value, where, fieldName, condition);
    }
    return where;
  }

}
